//@author: mandy

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SearchOptionsComponent } from "../search-options/search.options.component";

@TypeManagerDecorator("resource-settings")
@Component({
    selector: "resource-settings",
    template: `
        <h2 class="c-margin-bottom--single">Resource Search Settings</h2>
        <div class="ngBold c-margin-bottom--quarter">Resource Search Options</div>
        <div class="ngFinePrint c-margin-bottom--half">
            Select the basic options to make available for resource searches throughout 25Live.
        </div>
        <search-options prefType="S" prefName="25L_resource_system_options" objectName="resource"></search-options>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SearchOptionsComponent],
})
export class ResourceSettingsComponent implements OnInit {
    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.elementRef.nativeElement.angBridge = this; //bridge to AngularJS; used for AngJS to set model values and call setter fns
        this.cd.detectChanges();
    }
}
